<template>
  <div>
    <h1>Korisnici</h1>
    <div class="row">
      <div class="col-md-12">
        <button class="btn btn-primary" @click="createUser()">
          Novi korisnik
        </button>
        <button
          class="btn btn-primary mr-1 ml-1"
          v-if="selected.length > 0"
          @click="changeStatus"
        >
          Promjena statusa
        </button>
        <button
          class="btn btn-primary mr-1 ml-1"
          v-if="selected.length > 0 && selected[0].type === 'customer'"
          @click="deleteUser"
        >
          Delete
        </button>
      </div>
    </div>
    <div class="row pl-3 pr-3 mt-3">
      <div id="vueapp" class="vue-app" v-if="getUsers.length > 0">
        <v-data-table
          v-model="selected"
          :headers="columns"
          :items="getUsers"
          :single-select="true"
          :sort-desc="[true, true]"
          item-key="id"
          show-select
          class="elevation-1"
        >
          <template v-slot:item.status="{ item }">
            <span>{{
              item.status != undefined
                ? item.status
                  ? "Aktivan"
                  : "Nije aktivan"
                : "Aktivan"
            }}</span>
          </template>
        </v-data-table>
      </div>
      <div v-else>
        <h2>Trenutno nemamo kreiranih naloga. Kreiraj radni nalog !</h2>
      </div>
    </div>
  </div>
</template>

<script>
// import moment from "moment";
export default {
  created() {
    this.$store.dispatch("getAllUseres");
  },
  data() {
    return {
      selected: [],
      columns: [
        {
          value: "name", // create a column bound to the "name" field
          text: "Ime i prezime"
        },
        {
          value: "email",
          text: "Email"
        },
        {
          value: "type",
          text: "Tip naloga"
        },
        {
          value: "phoneNumber",
          text: "Broj telefona"
        },
        {
          value: "status",
          text: "Aktivan nalog"
        }
      ]
    };
  },
  methods: {
    createUser() {
      this.$router.push("/add-customer-user");
    },
    changeStatus() {
      const selectedUser = this.selected[0];
      let { id, status } = selectedUser;
      if (status !== undefined) status = !status;
      if (status === undefined || status === null) status = false;
      const payload = { id, status };
      this.$store.dispatch("changeUserStatus", payload);
    },
    deleteUser() {
      const selectedUser = this.selected[0];
      let { id } = selectedUser;
      this.$store.dispatch("deleteSelectedUser", id);
    }
  },
  computed: {
    getUsers() {
      return this.$store.getters.getUseres;
    }
  }
};
</script>

<style></style>
